import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { pagination } from 'utils/constants';

const initialState: IExternalIpWhitelistState = {
    list: [],
    paginateMetaData: pagination,
};

export const externalIpWhitelistSlice = createSlice({
    name: 'externalIpWhitelist',
    initialState,
    reducers: {
        setExternalIpWhitelistList: (
            state,
            action: PayloadAction<{
                list: IExternalIpWhitelist[];
                paginateMetaData: IPaginateMetaData;
            }>,
        ) => {
            state.list = action.payload.list;
            state.paginateMetaData = action.payload.paginateMetaData;
        },
    },
});

export const { setExternalIpWhitelistList } = externalIpWhitelistSlice.actions;

export default externalIpWhitelistSlice.reducer;
